<template src="./filter_bar.html"></template>

<script>

import {API_URL} from '@/main'
import axios from "axios"

import '@vuepic/vue-datepicker/dist/main.css'

export default {
  name: "FilterBar",
  data() {
    return {
      filter: {
        customer: '',
        start_date: '',
        end_date: '',
        currency: '',
        location1: '',
        location2: '',
        base: '',
        lower_bracket: '',
        upper_bracket: '',
        bracket_m_u: '',
        formula: '',
      },
    }
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style scoped>


</style>
